$(document).ready(function ()  {

$(document).on('click', '.itb_look_btn', function(e) {
    $('.itb_look_btn').removeClass('active');
    $(this).toggleClass('active');
    $('.lookbook'+$(this).attr('target')).toggleClass('active');
});
// feature collection
$('.featurecollection, .itb_testi_colsin').not('.slick-initialized').slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
          slidesToShow: 4
      }
    },
    {
      breakpoint: 1050,
      settings: {
          slidesToShow: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
          slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1
      }
    }
    ]
});
$(".featurecollection").show();
$(".itb_testi_colsin").show();
// Collection list
$(".itbcat").not('.slick-initialized').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true, 
    fade: false,
    centerMode: true,
    asNavFor: '.itbcat-one',
    responsive: [
        {
          breakpoint: 990,
            settings: {
                slidesToShow: 2
            }  
        }
    ]
});
$(".itbcat").show();
$('.itbcat-one').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.itbcat',
    dots: false,
    autoplaySpeed: 6000,
    autoplay:true,
    arrows:false,
    focusOnSelect: true
});
$(".itbcat-one").show();
// Back to top button
$(".back_to_top").addClass("hidden");
    $(window).scroll(function () {
    if ($(this).scrollTop() === 0) {
        $(".back_to_top").addClass("hidden")
    } else {
        $(".back_to_top").removeClass("hidden")
    }
});
$('.back_to_top').click(function () {
    $("html, body").animate({scrollTop: 0}, 600);
    return false;
});

setTimeout(function() {
    $('body').addClass('preloaded');
}, 1000);
  // Collections page grid Views
  $(document).on('click', '.itb_grides_nav', function(e) {
    $(this).addClass('active').siblings().removeClass('active');
    if ($(this).hasClass('grid_thr')) {
        $('#product-grid').addClass('grid--3-col-desktop').removeClass('grid--2-col-desktop').removeClass('grid--4-col-desktop');
    } else if ($(this).hasClass('gride_tw')) {
        $('#product-grid').addClass('grid--2-col-desktop').removeClass('grid--3-col-desktop').removeClass('grid--4-col-desktop');
    } else if ($(this).hasClass('gird_for')) {
        $('#product-grid').addClass('grid--4-col-desktop').removeClass('grid--3-col-desktop').removeClass('grid--2-col-desktop');
    }
  });
});